import { API } from "@/new_api";
import router from "@/router";
import setCookie from "@/utils/setCookie";
import { POPUP_MESSAGES, POPUP_NAMES } from "@/components/popups/components/enums";

const defaultState = {
  loading: false,
  paymentName: null,
  paymentItem: null,
  paymentId: null,
  uuid: null
}

const state = () => ({
  loading: defaultState.loading,
  paymentName: defaultState.paymentName,
  paymentItem: defaultState.paymentItem,
  paymentId: defaultState.paymentId,
  uuid: defaultState.uuid
})

const getters = {
  isLoading: state => state.loading,
  getPaymentId: state => state.paymentId,
  getPaymentName: state => state.paymentName,
  getPaymentItem: state => state.paymentItem,
  checkDevice: () => {
    let MobileUserAgent =
      navigator.userAgent || navigator.vendor || window.opera;

    if (
      MobileUserAgent.match(/iPhone/i) ||
      MobileUserAgent.match(/iPod/i) ||
      MobileUserAgent.match(/iPad/i)
    ) {
      return 'iOS';
    } else if (MobileUserAgent.match(/Android/i)) {
      return 'Android';
    } else {
      return 'Desktop';
    }
  },
  userUuid: state => {
    return state.uuid;
  }
}

const mutations = {
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_PAYMENT_INFO(state, payload) {
    const keys = Object.keys(payload);
    keys.forEach(key => {state[key] = payload[key]})
  },
  SET_UUID(state, payload) {
    state.uuid = payload;
  },
}

const actions = {
  async initCardPayment({commit, dispatch, state}, { body, onSuccess, onError }) {
    commit('SET_LOADING', true)
    const {amount, item, name, payment, gateway_id, gateway_account_id} = body;
    const payload = {
      currency_code: "USD",
      amount,
      payment_method_type: "card",
      web_user_uuid: state.uuid,
    }
    let is3dsError = false;

    if (gateway_id) payload.gateway_id = gateway_id;
    if (gateway_account_id) payload.gateway_id = gateway_account_id;

    try {
      const { data, status } = await API.PAYMENTS.card_init(payload);
      if (status === 200 || status === 204) {

        const payment_intent = await payment.authorizeWith3ds(data.payment_intent, {}, {
          error: (payment, error) => {
            is3dsError = true;
            const formError = String(error).split('code:');
            onError({ type: 'card', error: formError[0] || error, errorCode: formError[1] || 'card_declined_by_form' });
          }
        });

      if (payment_intent) onSuccess({name, item, intent_id: payment_intent.id, new_flow: true})
    }

    } catch (error) {
      this.dispatch('openPopup', {component: POPUP_NAMES.error, props: {message: POPUP_MESSAGES.declined}});
      if (!is3dsError) onError({ type: 'card', error });
      console.error('Payment Init Error', error);
      commit('SET_LOADING', false);
    }
  },

  async acceptCardPayment({commit, state, getters}, { body, onSuccess, onError }) {
    commit('SET_LOADING', true);

    try {
      const { status } = await API.PAYMENTS.card_accept({ ...body, web_user_uuid: state.uuid  });
      if (status === 200 || status === 204) onSuccess()

    } catch(error) {
      onError({ type: 'card', error: error?.response?.data || error, errorCode: 'init_user_error' })
      this.dispatch('openPopup', {component: POPUP_NAMES.error, props: {message: POPUP_MESSAGES.declined}})
    } finally {
      setTimeout(() => {
        commit('SET_LOADING', false);
      }, 1000)
    }
  },

  async initWalletPayment({commit}, payload) {
    try {
      const { data, status } = await API.PAYMENTS.card_init(payload)
      if (status === 200 || status === 204) {
        return data;
      }
    } catch (error) {
      this.dispatch('openPopup', {component: POPUP_NAMES.error, props: {message: POPUP_MESSAGES.declined}})
      console.error('Init wallet payment error', error)
    }
  },

  async acceptWalletPayment({commit, getters}, { body, onSuccess, onError }) {
    commit('SET_LOADING', true);
    try {
      const { status } = await API.PAYMENTS.card_accept(body);
        if (status === 200 || status === 204) onSuccess();
    } catch (error) {
      onError({ stage: 'ApplePay', error });
      console.error(error);
      return error;
    } finally {
      setTimeout(() => {
        commit('SET_LOADING', false);
      }, 1000)
    }
  },
  async upsellPayment({commit}, { body, onSuccess, onError }) {
    commit('SET_LOADING', true);

    try {
      const { status } = await API.PAYMENTS.addons(body);
      if (status === 200 || status === 204) {
        onSuccess()
      }
    } catch (error) {
      onError(error)
      console.error(error)
    } finally {
      setTimeout(() => {
        commit('SET_LOADING', false);
      }, 1000)
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
